import { createQueryKeys } from '@lukemorales/query-key-factory'
import type { inferQueryKeys } from '@lukemorales/query-key-factory'

export const marketingMaterials = createQueryKeys('marketingMaterials', {
  all: null,
  allPaginated: (query?: any) => [query],
})

export type MarketingMaterialsKeys = inferQueryKeys<typeof marketingMaterials>
